var map = {
	"./generica_fall.svg": "a6ad",
	"./generica_generica.svg": "dd21",
	"./generica_spring.svg": "ab9d",
	"./generica_summer.svg": "1b6d",
	"./generica_winter.svg": "140a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9272";